'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/link.ts
var LINK_QUERY = `
id
label
href
deeplinkHref
theme
shape
isExternal
iconPosition
icon {${IMAGE_QUERY}}
image {${IMAGE_QUERY}}`;

export {
  LINK_QUERY
};
//# sourceMappingURL=chunk-Y5YNZ765.mjs.map